import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/PrivacyPolicy/PrivacyPolicy.module.css';

function PrivacyPolicy() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <div className={styles.pageContainer}>
      <Header />
      <main className={styles.contactContent}>
        <section className={styles.contactHero}>
          <h1>Polityka Prywatności</h1>
          <p>Twoje dane są u nas bezpieczne. Dowiedz się, jak o nie dbamy.</p>
          <p>Warunki korzystania z serwisu Czateria24.pl</p>
        </section>

        <div className={styles.contactCard} style={{ textAlign: 'left', lineHeight: '1.8' }}>

          <section>
            <h3>1. Wyłączenie odpowiedzialności Administratora</h3>
            <p>Na podstawie <em>art. 14 ustawy o świadczeniu usług drogą elektroniczną</em>, Administrator nie ponosi odpowiedzialności za treści, wiadomości, obrazy ani linki przesyłane przez Użytkowników w ramach czatu. Administrator nie posiada wiedzy o bezprawnym charakterze danych wprowadzanych przez Użytkowników.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>2. Całkowite wyłączenie odpowiedzialności i zrzeczenie się roszczeń</h3>
            <p>
              Na podstawie <em>art. 14 i 15 ustawy o świadczeniu usług drogą elektroniczną</em>, Administrator oraz podmioty świadczące usługi hostingowe dla serwisu Czateria24.pl są całkowicie zwolnieni z odpowiedzialności za treści (wiadomości, obrazy, linki) publikowane przez użytkowników.
            </p>
            <p>
              Wchodząc do serwisu Czateria24.pl, użytkownik przyjmuje do wiadomości i bezwarunkowo zgadza się na zrzeczenie się wszelkich roszczeń prawnych oraz finansowych wobec Administratora i firmy hostingowej z tytułu jakichkolwiek szkód, naruszeń dóbr osobistych lub sporów wynikających z interakcji z innymi użytkownikami.
            </p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>3. Informacje ogólne</h3>
            <p>Serwis Czateria24 określa zasady przetwarzania danych osobowych oraz wykorzystywania plików cookies w celu zapewnienia bezpieczeństwa i stabilności portalu.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>4. Administrator Danych</h3>
            <p>Administratorem danych osobowych jest Czateria24.pl. Kontakt: <strong>kontakt@czateria24.pl</strong>. Administrator nie ma obowiązku monitorowania treści, ale reaguje na zgłoszenia naruszeń (procedura Notice & Takedown).</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>5. Zakres zbieranych danych</h3>
            <p>Przetwarzamy: adres IP (dla bezpieczeństwa i blokowania spamerów), adres e-mail (opcjonalnie) oraz nazwę użytkownika (nick). Dane te mogą być udostępniane wyłącznie uprawnionym organom państwowym.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>6. Cel i czas przetwarzania</h3>
            <p>Dane są przetwarzane w celu moderacji, walki z botami oraz statystyk. Logi połączeń są przechowywane przez okres 90 dni dla celów dowodowych.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>7. Pliki Cookies</h3>
            <p>Cookies służą do zapamiętywania ustawień sesji oraz trybu kolorystycznego strony.</p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>8. Wymagania wiekowe (18+)</h3>
            <p>
              Serwis Czateria24.pl przeznaczony jest wyłącznie dla osób, które ukończyły <strong>18 rok życia</strong>. Korzystanie z usług przez osoby nieletnie jest surowo zabronione.
            </p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>8. Oświadczenie użytkownika:</h3>
            <p>
              Wchodząc do serwisu, użytkownik oświadcza, że jest pełnoletni. Administrator nie ponosi odpowiedzialności za podanie nieprawdziwych informacji dotyczących wieku przez użytkownika w celu obejścia zabezpieczeń lub regulaminu.
            </p>
          </section>

          <section style={{ marginTop: '20px' }}>
            <h3>10. Zmiany w Polityce</h3>
            <p>Administrator zastrzega sobie prawo do zmian w niniejszym dokumencie. Dalsze korzystanie z serwisu po wprowadzeniu zmian oznacza ich pełną akceptację.</p>
          </section>
        </div>
      </main>

      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>
          <div className={styles.disclaimer}>
            <p>Wchodząc do serwisu akceptujesz regulamin i zrzekasz się roszczeń wobec Administratora. 18+.</p>
          </div>
          <div className={styles.copyright}>© Czateria24. Wszystkie prawa zastrzeżone.</div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;